import styles from './SearchPageFeatures.module.scss';

const ProfileManagementIcon = () => (
  <svg
    fill="none"
    height="125"
    viewBox="0 0 125 125"
    width="125"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      height="123"
      rx="23"
      stroke="#0d8bff"
      strokeWidth="2"
      width="123"
      x="1"
      y="1"
    />
    <path
      d="M27.6795 86.0117C27.5384 86.4706 27.3268 86.8588 27.0095 87.1764C26.6921 87.4941 26.3394 87.7411 25.8457 87.9176C25.3872 88.0941 24.8229 88.2 24.1881 88.2H23.0596C22.4248 88.2 21.8605 88.0941 21.3668 87.9176C20.9084 87.7411 20.5204 87.4941 20.203 87.1764C19.8856 86.8588 19.7093 86.4706 19.5682 86.0117C19.4272 85.5529 19.3566 85.0588 19.3566 84.4941V83.1529C19.3566 82.5882 19.4272 82.0941 19.5682 81.6353C19.7093 81.1764 19.9209 80.7882 20.2383 80.4706C20.5204 80.1176 20.9084 79.8706 21.4021 79.6941C21.8605 79.5176 22.4248 79.447 23.0949 79.447H24.2234C24.8582 79.447 25.4225 79.5176 25.8809 79.6941C26.3394 79.8706 26.7273 80.1176 27.0447 80.4353C27.3621 80.7529 27.5737 81.1411 27.7148 81.6C27.8558 82.0588 27.9264 82.5529 27.9264 83.1176V84.4588C27.9264 85.0588 27.8558 85.5529 27.6795 86.0117ZM21.261 86.4706C21.5784 86.8588 22.1427 87.0353 22.9185 87.0353H24.3997C25.1756 87.0353 25.7399 86.8588 26.0573 86.4706C26.3747 86.0823 26.551 85.5176 26.551 84.7764V82.8C26.551 82.0235 26.3747 81.4588 26.0573 81.1058C25.7399 80.7176 25.1756 80.5411 24.3997 80.5411H22.9185C22.1427 80.5411 21.6137 80.7176 21.261 81.1058C20.9436 81.4941 20.7673 82.0588 20.7673 82.8353V84.8117C20.7673 85.5529 20.9436 86.1176 21.261 86.4706Z"
      fill="#0d8bff"
    />
    <path
      d="M35.4029 88.3411C35.0502 88.3411 34.7328 88.2352 34.5212 88.0588C34.3096 87.8823 34.098 87.6352 33.9217 87.3529L31.0298 82.6941C30.9593 82.5882 30.924 82.5176 30.8888 82.4823C30.8888 82.447 30.8535 82.447 30.8182 82.447C30.7477 82.447 30.7477 82.4823 30.7477 82.4823C30.7124 82.5176 30.7124 82.5882 30.7124 82.6588V88.2705H29.4076V82.6588C29.4076 82.2352 29.5134 81.8823 29.725 81.5999C29.9366 81.2823 30.2892 81.1411 30.783 81.1411C31.1356 81.1411 31.4178 81.247 31.6293 81.4588C31.8409 81.6352 32.0525 81.9176 32.2641 82.2705L35.1207 86.8588C35.156 86.9293 35.2265 86.9999 35.2618 87.0352C35.2971 87.0705 35.2971 87.0705 35.3323 87.0705C35.3676 87.0705 35.3676 87.0705 35.4029 87.0352C35.4381 86.9999 35.4381 86.9646 35.4381 86.8941V81.247H36.743V86.8588C36.743 87.2823 36.6372 87.6352 36.4256 87.8823C36.1435 88.1999 35.8261 88.3411 35.4029 88.3411Z"
      fill="#0d8bff"
    />
    <path
      d="M44.5369 90H40.6576C39.388 90 38.33 88.9412 38.33 87.6706V80.3294C38.33 79.0588 39.388 78 40.6576 78H44.5369C45.8417 78 46.8645 79.0588 46.8645 80.3294V87.7059C46.8645 88.9765 45.8417 90 44.5369 90Z"
      fill="#0d8bff"
    />
    <path
      d="M42.8441 88.3411C42.7736 88.3411 42.7383 88.3411 42.6678 88.3411H40.058V86.6117H42.9499C43.232 86.5764 43.4436 86.3647 43.4789 86.1176C43.4789 86.0823 43.4789 86.047 43.4789 85.9764C43.4789 85.3058 42.2798 84.847 41.7508 84.3882V83.647C42.2446 83.1882 43.4789 82.6941 43.4789 82.0588C43.4789 82.0235 43.4789 81.9882 43.4789 81.9176C43.4436 81.6705 43.232 81.4588 42.9499 81.4235H40.0228V79.7294H42.6325C42.703 79.7294 42.7736 79.7294 42.8088 79.7294C42.8794 79.7294 42.9146 79.7294 42.9852 79.7294C44.0079 79.8 44.8895 80.5411 45.1011 81.5294C45.1364 81.6705 45.1364 81.8117 45.1364 81.9882C45.1364 82.7294 44.7485 83.4353 44.1137 83.8588L43.9021 84.0353L44.1137 84.2117C44.7485 84.6353 45.1364 85.3411 45.1364 86.0823C45.1364 86.2235 45.1364 86.4 45.1011 86.5411C44.8895 87.5294 44.0431 88.2705 42.9852 88.3411C42.9852 88.3411 42.9146 88.3411 42.8441 88.3411Z"
      fill="white"
    />
    <path d="M51.167 81.4236H49.8974V86.5765H51.167V81.4236Z" fill="#0d8bff" />
    <path
      d="M47.9528 83.3749V84.6455H53.1017V83.3749H47.9528Z"
      fill="#0d8bff"
    />
    <path
      d="M99.1383 79.884H101.778C102.802 79.884 103.598 80.224 104.166 80.904C104.734 81.584 105.018 82.576 105.018 83.88C105.018 85.264 104.734 86.316 104.166 87.036C103.598 87.756 102.802 88.116 101.778 88.116H99.1383V79.884ZM101.646 86.892C102.262 86.892 102.742 86.664 103.086 86.208C103.43 85.744 103.602 85.068 103.602 84.18V83.58C103.602 82.772 103.43 82.16 103.086 81.744C102.742 81.32 102.262 81.108 101.646 81.108H100.518V86.892H101.646Z"
      fill="#0d8bff"
    />
    <path
      d="M92.4258 79.884H97.6218V81.108H93.8058V83.292H97.0938V84.516H93.8058V86.892H97.6938V88.116H92.4258V79.884Z"
      fill="#0d8bff"
    />
    <path d="M89.4734 79.884H90.8414V88.116H89.4734V79.884Z" fill="#0d8bff" />
    <path
      d="M83.3837 79.884H88.1957V81.108H84.7637V83.388H87.7277V84.612H84.7637V88.116H83.3837V79.884Z"
      fill="#0d8bff"
    />
    <path d="M80.4312 79.884H81.7992V88.116H80.4312V79.884Z" fill="#0d8bff" />
    <path
      d="M73.2516 79.884H76.6596C77.4596 79.884 78.0756 80.096 78.5076 80.52C78.9396 80.944 79.1556 81.508 79.1556 82.212C79.1556 82.716 79.0316 83.152 78.7836 83.52C78.5356 83.888 78.1916 84.156 77.7516 84.324L79.3596 88.116H77.8596L76.4316 84.612H74.6316V88.116H73.2516V79.884ZM76.5036 83.388C76.8876 83.388 77.1796 83.284 77.3796 83.076C77.5876 82.868 77.6916 82.58 77.6916 82.212C77.6916 81.868 77.5956 81.6 77.4036 81.408C77.2116 81.208 76.9236 81.108 76.5396 81.108H74.6316V83.388H76.5036Z"
      fill="#0d8bff"
    />
    <path
      d="M66.5391 79.884H71.7351V81.108H67.9191V83.292H71.2071V84.516H67.9191V86.892H71.8071V88.116H66.5391V79.884Z"
      fill="#0d8bff"
    />
    <path
      d="M59.1066 79.884H60.5466L62.3826 86.184H62.4306L64.2666 79.884H65.5986L63.0906 88.116H61.6146L59.1066 79.884Z"
      fill="#0d8bff"
    />
    <path
      d="M73.3438 56V58H79.3438V56H73.3438ZM73.3438 44V46H83.3438V44H73.3438ZM83.3438 60V58H91.3438V56H83.3438V54H81.3438V60H83.3438ZM77.3438 48V50H73.3438V52H77.3438V54H79.3438V48H77.3438ZM91.3438 52V50H81.3438V52H91.3438ZM85.3438 48H87.3438V46H91.3438V44H87.3438V42H85.3438V48Z"
      fill="#0d8bff"
    />
    <path
      d="M55.5 40.4438C57.6025 40.4438 59.3063 42.1475 59.3063 44.25C59.3063 46.3525 57.6025 48.0563 55.5 48.0563C53.3975 48.0563 51.6937 46.3525 51.6937 44.25C51.6937 42.1475 53.3975 40.4438 55.5 40.4438ZM55.5 56.7562C60.8831 56.7562 66.5563 59.4025 66.5563 60.5625V62.5563H44.4438V60.5625C44.4438 59.4025 50.1169 56.7562 55.5 56.7562ZM55.5 37C51.4944 37 48.25 40.2444 48.25 44.25C48.25 48.2556 51.4944 51.5 55.5 51.5C59.5056 51.5 62.75 48.2556 62.75 44.25C62.75 40.2444 59.5056 37 55.5 37ZM55.5 53.3125C50.6606 53.3125 41 55.7412 41 60.5625V66H70V60.5625C70 55.7412 60.3394 53.3125 55.5 53.3125Z"
      fill="#0d8bff"
    />
  </svg>
);

const ScoutingReportsIcon = () => (
  <svg
    fill="none"
    height="125"
    viewBox="0 0 125 125"
    width="125"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      height="123"
      rx="23"
      stroke="#0d8bff"
      strokeWidth="2"
      width="123"
      x="1"
      y="1"
    />
    <path
      d="M52 37H45.73C45.1 35.26 43.45 34 41.5 34C39.55 34 37.9 35.26 37.27 37H31C29.35 37 28 38.35 28 40V61C28 62.65 29.35 64 31 64H52C53.65 64 55 62.65 55 61V40C55 38.35 53.65 37 52 37ZM41.5 37C42.325 37 43 37.675 43 38.5C43 39.325 42.325 40 41.5 40C40.675 40 40 39.325 40 38.5C40 37.675 40.675 37 41.5 37ZM41.5 43C43.99 43 46 45.01 46 47.5C46 49.99 43.99 52 41.5 52C39.01 52 37 49.99 37 47.5C37 45.01 39.01 43 41.5 43ZM50.5 61H32.5V58.9C32.5 55.9 38.5 54.25 41.5 54.25C44.5 54.25 50.5 55.9 50.5 58.9V61Z"
      fill="#0d8bff"
    />
    <rect fill="#0d8bff" height="3" transform="translate(61 58)" width="12" />
    <rect fill="#0d8bff" height="3" transform="translate(61 48)" width="38" />
    <rect fill="#0d8bff" height="3" transform="translate(61 38)" width="23" />
    <rect
      height="14.5"
      rx="1.25"
      stroke="#0d8bff"
      strokeWidth="1.5"
      width="14.5"
      x="64.75"
      y="69.75"
    />
    <path
      d="M76.6381 72H67.3619C67.162 72 67 72.1728 67 72.386V72.814C67 73.0272 67.162 73.2 67.3619 73.2H76.6381C76.838 73.2 77 73.0272 77 72.814V72.386C77 72.1728 76.838 72 76.6381 72Z"
      fill="#0d8bff"
    />
    <path
      d="M76.6381 75H67.3619C67.162 75 67 75.1728 67 75.386V75.814C67 76.0272 67.162 76.2 67.3619 76.2H76.6381C76.838 76.2 77 76.0272 77 75.814V75.386C77 75.1728 76.838 75 76.6381 75Z"
      fill="#0d8bff"
    />
    <path
      d="M61 71.4343L61 82.5657C61 82.8056 61.216 83 61.4825 83L62.0175 83C62.284 83 62.5 82.8056 62.5 82.5657L62.5 71.4343C62.5 71.1944 62.284 71 62.0175 71L61.4825 71C61.216 71 61 71.1944 61 71.4343Z"
      fill="#0d8bff"
    />
    <path
      d="M76.6381 78H67.3619C67.162 78 67 78.1728 67 78.386V78.814C67 79.0272 67.162 79.2 67.3619 79.2H76.6381C76.838 79.2 77 79.0272 77 78.814V78.386C77 78.1728 76.838 78 76.6381 78Z"
      fill="#0d8bff"
    />
    <path
      d="M69.8914 81H67.1086C67.0486 81 67 81.144 67 81.3217V81.6783C67 81.856 67.0486 82 67.1086 82H69.8914C69.9514 82 70 81.856 70 81.6783V81.3217C70 81.144 69.9514 81 69.8914 81Z"
      fill="#0d8bff"
    />
  </svg>
);

const CoachDirectoryIcon = () => (
  <svg
    fill="none"
    height="125"
    viewBox="0 0 125 125"
    width="125"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      height="123"
      rx="23"
      stroke="#0d8bff"
      strokeWidth="2"
      width="123"
      x="1"
      y="1"
    />
    <path
      d="M55.125 53.125H42.625L39.5 50H30.125C28.4062 50 27.0156 51.4062 27.0156 53.125L27 71.875C27 73.5938 28.4062 75 30.125 75H55.125C56.8438 75 58.25 73.5938 58.25 71.875V56.25C58.25 54.5312 56.8438 53.125 55.125 53.125ZM55.125 71.875H30.125V56.25H55.125V71.875Z"
      fill="#0d8bff"
    />
    <path
      d="M91.0001 21.6666H75.0001C74.2667 21.6666 73.6667 22.2666 73.6667 23V39C73.6667 39.7333 74.2667 40.3333 75.0001 40.3333H91.0001C91.7334 40.3333 92.3334 39.7333 92.3334 39V23C92.3334 22.2666 91.7334 21.6666 91.0001 21.6666ZM83.0001 25.3333C84.6534 25.3333 86.0001 26.68 86.0001 28.3333C86.0001 29.9866 84.6534 31.3333 83.0001 31.3333C81.3467 31.3333 80.0001 29.9866 80.0001 28.3333C80.0001 26.68 81.3467 25.3333 83.0001 25.3333ZM89.0001 37.6666H77.0001V36.6666C77.0001 34.6666 81.0001 33.6666 83.0001 33.6666C85.0001 33.6666 89.0001 34.6666 89.0001 36.6666V37.6666Z"
      fill="#0d8bff"
    />
    <path
      d="M91.0001 87H75.0001C74.2667 87 73.6667 87.6 73.6667 88.3333V104.333C73.6667 105.067 74.2667 105.667 75.0001 105.667H91.0001C91.7334 105.667 92.3334 105.067 92.3334 104.333V88.3333C92.3334 87.6 91.7334 87 91.0001 87ZM83.0001 90.6667C84.6534 90.6667 86.0001 92.0133 86.0001 93.6667C86.0001 95.32 84.6534 96.6667 83.0001 96.6667C81.3467 96.6667 80.0001 95.32 80.0001 93.6667C80.0001 92.0133 81.3467 90.6667 83.0001 90.6667ZM89.0001 103H77.0001V102C77.0001 100 81.0001 99 83.0001 99C85.0001 99 89.0001 100 89.0001 102V103Z"
      fill="#0d8bff"
    />
    <rect fill="#0d8bff" height="3" transform="translate(58 62)" width="8" />
    <rect fill="#0d8bff" height="3" transform="translate(64 30)" width="8" />
    <rect fill="#0d8bff" height="3" transform="translate(64 94)" width="8" />
    <rect
      fill="#0d8bff"
      height="3"
      transform="translate(64 69) rotate(-90)"
      width="11"
    />
    <rect
      fill="#0d8bff"
      height="3"
      transform="translate(64 55) rotate(-90)"
      width="25"
    />
    <rect
      fill="#0d8bff"
      height="3"
      transform="translate(64 97) rotate(-90)"
      width="25"
    />
  </svg>
);

const NilValuationIcon = () => (
  <svg
    fill="none"
    height="125"
    viewBox="0 0 125 125"
    width="125"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      height="123"
      rx="23"
      stroke="#0d8bff"
      strokeWidth="2"
      width="123"
      x="1"
      y="1"
    />
    <path
      d="M45.8542 88.9179L57.6042 77.1484L65.4375 84.9817L82.0833 66.26L79.3221 63.4988L65.4375 79.1067L57.6042 71.2734L42.9167 85.9804L45.8542 88.9179Z"
      fill="#0d8bff"
    />
    <path
      d="M63.179 52.7519C59.2275 51.7248 57.9567 50.663 57.9567 49.0093C57.9567 47.1119 59.7149 45.7889 62.6567 45.7889C65.7552 45.7889 66.9041 47.2685 67.0086 49.4444H70.8556C70.7338 46.4504 68.906 43.7 65.2678 42.8122V39H60.0456V42.76C56.6686 43.4911 53.953 45.6844 53.953 49.0441C53.953 53.0652 57.2778 55.067 62.1345 56.2333C66.4864 57.2778 67.3567 58.8096 67.3567 60.4285C67.3567 61.6296 66.5038 63.5444 62.6567 63.5444C59.0708 63.5444 57.6608 61.943 57.4693 59.8889H53.6397C53.8486 63.7011 56.7034 65.8422 60.0456 66.5559V70.3333H65.2678V66.5907C68.6623 65.9467 71.3604 63.9796 71.3604 60.4111C71.3604 55.4674 67.1304 53.7789 63.179 52.7519Z"
      fill="#0d8bff"
    />
  </svg>
);

export const SearchPageFeatures = () => (
  <div className={styles.block}>
    <h2>
      On3+ Recruits offers athletes and families all the tools they need to get
      exposure and navigate the recruiting process and NIL.
    </h2>

    <div className={styles.features}>
      <div className={styles.feature}>
        <ProfileManagementIcon />
        <h3>Profile Management</h3>
        <p className="sr-only">Manage your profile and keep it up to date.</p>
      </div>
      <div className={styles.feature}>
        <ScoutingReportsIcon />
        <h3>Scouting Reports</h3>
        <p className="sr-only">
          View scouting reports from our team of experts.
        </p>
      </div>
      <div className={styles.feature}>
        <CoachDirectoryIcon />
        <h3>Coach Directory</h3>
        <p className="sr-only">Find contact information for college coaches.</p>
      </div>
      <div className={styles.feature}>
        <NilValuationIcon />
        <h3>Nil Valuation</h3>
        <p className="sr-only">
          Get a valuation of your profile from our team.
        </p>
      </div>
    </div>

    <div>
      <span className={styles.subscription}>Free On3 Access</span>
    </div>
  </div>
);
